import React from "react";
import { Box } from "@mui/material";
import { NormalText } from "../../../../components/TextParts";

export default function InfoParts({ head, info }) {
  return (
    <Box sx={{ display: "flex", pb: "5px" }}>
      <Box sx={{ width: "120px" }}>
        <NormalText text={head} />
      </Box>
      <Box sx={{ width: "calc(100% - 120px)" }}>
        <NormalText text={info} />
      </Box>
    </Box>
  );
}